import React from "react"
import Layout from "../../components/layout"
import FreeTrialStrip from "../../components/layoutComponents/FreeTrialStrip"
import HeroVideo from "../../components/layoutComponents/HeroVideo"
import ActivityTimeline from "../../components/layoutComponents/platform/offers/ActivityTimeline"
import BuildHighConvertingOffersWithEase from "../../components/layoutComponents/platform/offers/BuildHighConvertingOffers"
import FlexibleDates from "../../components/layoutComponents/platform/offers/FlexibleDates"
import OfferPowerfulActions from "../../components/layoutComponents/platform/offers/OfferPowerfulActions"

import Testimonials from "../../components/layoutComponents/Testimonials"

import OfferHeaderImage from "../../components/staticQuery/platform/offers/OfferHeaderImage"
import { babyBlueColor } from "../../theme"
import P from "../../components/typography/P"

const seo = {
  title: "Digital Offers",
  description: "Learn about what you can do with MindMe's Digital Offers.",
}

const Description = () => (
  <>
    <P>
      Offers are digital coupons designed to create urgency and engage your
      audience. Use them to capture more opt-ins, convert leads to customers,
      generate repeat sales and increase purchase amounts.
    </P>
    <P>
      Stop sending static, untrackable coupons and immediately get the benefits
      of our dynamically created Offers. Track redemptions, eliminate
      unauthorized usage, create flexible effective dates and turn on Actions
      based on Offer activity.
    </P>
    <P>
      <strong>Engage Your Audience!</strong>
    </P>
  </>
)

const header = (
  <HeroVideo
    title="Offers"
    description={<Description />}
    media={<OfferHeaderImage />}
    tint={babyBlueColor}
    clipPath="polygon(0 0, 100% 0, 100% 100%, 0 calc(100% - 6vw))"
  />
)

const main = (
  <>
    <FlexibleDates />
    <OfferPowerfulActions />
    <ActivityTimeline />
    <BuildHighConvertingOffersWithEase />
    <FreeTrialStrip />
    <Testimonials />
  </>
)

const OffersPage = () => <Layout header={header} main={main} seo={seo} />

export default OffersPage
